module.exports = __webpack_public_path__ + "img/banner.cd1292cd.jpeg";